
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/requests/repair",
      function () {
        return require("private-next-pages/requests/repair/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/requests/repair"])
      });
    }
  